<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeTransfers.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="120"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeTransfer"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-transfer="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeTransfers.meta && representativeTransfers.meta.per_page"
        layout="total, prev, pager, next"
        :total="representativeTransfers.meta && representativeTransfers.meta.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      representativeTransfers() {
        return this.$store.getters['representativeTransfer/representativeTransfers']
      },

      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeTransfer/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeTransfer/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeTransfer/setFilterString', '');
      this.$store.commit('representativeTransfer/setCurrentPage', this.currentPage);
      this.$store.commit('representativeTransfer/setSorting', this.currentSort);
      await this.$store.dispatch('representativeTransfer/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeTransfer/setCurrentPage', val);
        this.$store.dispatch('representativeTransfer/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeTransfer/setSorting', { prop, order});
          this.$store.dispatch('representativeTransfer/fetchAll');
        }
      },
    },
  };
</script>
